import React from 'react';
import { Button } from 'reactstrap';
import { ClipLoader } from 'react-spinners';
import styled from 'styled-components';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';

const FlexButton = styled(Button)`
  display: flex !important;
  align-items: center;
`;
const FlexLoginButton = styled(Button)`
  
  
  margin-top:25px;
  align-items: center;
`;

const icon = css`
  margin-right: 10px !important;
`;


const SpinnerButton = (props) => {
  const { loading, type, text, color } = props;
  if (color) {
    return (
      <div>
        <FlexLoginButton
          type={type}
          color={color}
        >
          {
            loading ? <ClipLoader css={icon} size={16} color="#fff" /> : ''
          }
          {text}
        </FlexLoginButton>
      </div>
    )
  }
  return (
    <div>
      <FlexButton
        type={type}
      >
        {
          loading ? <ClipLoader css={icon} size={16} color="#fff" /> : ''
        }
        {text}
      </FlexButton>
    </div>
  );
};

SpinnerButton.propTypes = {
  loading: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default SpinnerButton;
